<template>
  <div v-if="item">
    <el-row align="middle" type="flex" justify="center" :gutter="10">
      <el-col :sm="{span: 12}" :lg="{span: 12}">
        <h1>{{item.Name}}</h1>
        <p>
          <i>{{item.LatinName}}</i>
        </p>
        <div>
          <span class="pad-button" v-for="badge in oilBadges()" v-bind:key="badge.Id">
            <b-icon
              hasDialog
              :name="badge"
              :content="description[badge]"
              :title="title[badge]"
              height="30px"
            ></b-icon>
          </span>
        </div>
        <el-collapse v-model="activeCollapse">
          <el-collapse-item title="Description" name="1">
            <div class="justify-text" v-html="getHtml(item.Description)"></div>
          </el-collapse-item>
          <el-collapse-item title="Primary Uses" name="2">
            <span class="pad-button" v-for="use in item.PrimaryUses" v-bind:key="use.Id">
              <use-button
                @select="handleSelectUse"
                v-if="use"
                :useCategory="getCategory(use.UseCategoryId)"
              />
            </span>
          </el-collapse-item>
          <el-collapse-item title="Secondary Uses" name="3">
            <span class="pad-button" v-for="use in item.SecondaryUses" v-bind:key="use.Id">
              <use-button
                @select="handleSelectUse"
                v-if="use"
                :useCategory="getCategory(use.UseCategoryId)"
              />
            </span>
          </el-collapse-item>
          <el-collapse-item title="Other Uses" name="4">
            <span class="pad-button" v-for="use in item.OtherUses" v-bind:key="use.Id">
              <use-button
                @select="handleSelectUse"
                v-if="use"
                :useCategory="getCategory(use.UseCategoryId)"
              />
            </span>
          </el-collapse-item>
        </el-collapse>
        <br>
        <el-tabs type="border-card" v-model="activeTab">
          <el-tab-pane label="Details" name="Details">
            <div v-html="getHtml(item.Details)"></div>
          </el-tab-pane>
          <el-tab-pane label="Safety" name="Safety">
            <div v-html="getHtml(item.Safety)"></div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { DESCRIPTION, TITLE } from '@/assets/data/oilTypes.js'
import { mapGetters } from 'vuex'
import UseButton from '@/components/uses/UseButton'
import { parseHtml } from '@/helper'

export default {
  props: {
    itemId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      activeCollapse: ['1', '2'],
      activeTab: 'Details',
      description: DESCRIPTION,
      title: TITLE
    }
  },
  computed: {
    ...mapGetters(['categories', 'getCatelog']),
    item() {
      if (!this.getCatelog[0]) return null
      const type = this.$route.params.type
      return this.getCatelog[type].find(i => i.Id === this.itemId)
    }
  },
  methods: {
    getCategory(UseCategoryId) {
      return this.categories.find(c => c.Id === UseCategoryId)
    },
    handleSelectUse(item) {
      this.$router.push({ path: '/uses/' + item.Id })
    },
    getHtml(text) {
      return parseHtml(text)
    },
    oilBadges() {
      const badges = this.item.OilBadges
      if (typeof badges === 'string') {
        const replaced = badges.replace(/,/g, '')
        return replaced
      } else return badges
    }
  },
  components: {
    UseButton
  }
}
</script>

<style scoped>
.pad-button {
  padding: 10px;
}
.justify-text {
  text-align: justify;
}
</style>
